<button
  [class.ui-atom-button-icon]="true"
  [class.coming-soon]="comingSoon"
  (click)="onClick($event)"
  [disabled]="disabled"
  [matTooltip]="tooltip"
  [matTooltipShowDelay]="tooltipShowDelay"
>
  <mat-icon [fontSet]="fontSet || ''">{{ icon }}</mat-icon>
</button>
